import { useGame } from "../../../data/gameContext";

export default function Jail() {
    const {updateGameState} = useGame();
    return (
        <div className="town-container">
            The Sheriffs Office
            <button onClick={() => updateGameState({Phase: 'townView'})}>Leave</button>
        </div>
    )
}